import React from 'react';

export default function NotAuthenticated(){
	return <div className="lone_wrapper">You are not allowed to access this area.</div>;
}



// WEBPACK FOOTER //
// ./src/components/NotAuthenticated.js